/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How often should I run a 1-minute test?`)
};

const es_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Con qué frecuencia debo hacer un test de 1 minuto?`)
};

const de_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie oft sollte ich einen 1-Minuten-Test machen?`)
};

const nl_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe vaak moet ik een test van 1 minuut doen?`)
};

const fr_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À quelle fréquence dois-je faire un test d'1 minute ?`)
};

const it_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni quanto dovrei fare un test da 1 minuto?`)
};

const pt_br2_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com que frequência devo fazer um teste de 1 minuto?`)
};

const pt_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com que frequência devo fazer um teste de 1 minuto?`)
};

const ja_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分間のテストはどのくらいの頻度で行うべきですか？`)
};

const zh_typing_u1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我应该多久进行一次1分钟测试？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u1_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u1_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u1_faq4_q", locale)
	if (locale === "en") return en_typing_u1_faq4_q(inputs)
	if (locale === "es") return es_typing_u1_faq4_q(inputs)
	if (locale === "de") return de_typing_u1_faq4_q(inputs)
	if (locale === "nl") return nl_typing_u1_faq4_q(inputs)
	if (locale === "fr") return fr_typing_u1_faq4_q(inputs)
	if (locale === "it") return it_typing_u1_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u1_faq4_q(inputs)
	if (locale === "pt") return pt_typing_u1_faq4_q(inputs)
	if (locale === "ja") return ja_typing_u1_faq4_q(inputs)
	return zh_typing_u1_faq4_q(inputs)
};